// services/locations/getStates.js
import axiosInstance from '../axiosMiddleware';

export async function getStates(countryId) {
  try {
    const response = await axiosInstance.post('location/states', { countryId });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}